import { useCallback, useEffect, useState } from 'react'

import { subscibeTo } from 'app/common/data-box-store'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { detailsFilter } from 'app/common/ui-next/_filter-compilations/details'

import PlainItemsSelectorBox, {
  StatusOnEmpty,
} from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'

import {
  foodResponsibleSignatoresFilter,
  foodResponsibleSignatoresFilterSelection,
  orderByClassesGroupFilterSelection,
  orgsFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = {
  id: string
  pending: boolean
}

export const FoodResponsibleSignatoresFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)

  const handleDetailsGroupFilter = useCallback(() => {
    if (
      detailsFilter.data &&
      orderByClassesGroupFilterSelection.data ===
        OrderByClassesDetailsGroup.ByComplexesAndAllowances
    ) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    const unsubscribeFromDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      detailsFilter.id,
      handleDetailsGroupFilter,
    )
    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    const unsubscribeBuildingsFromOrgs = orgsFilterSelection.subscribeDataBox(
      foodResponsibleSignatoresFilter,
    )
    return () => {
      unsubscribeFromDetailsGroup()
      unsubsribeDetailsGroup()
      unsubscribeBuildingsFromOrgs()
    }
  }, [handleDetailsGroupFilter])

  return (
    filterVisibility && (
      <PlainItemsSelectorBox
        id={id}
        label="Ответственный по питанию"
        header="Выбор ответственного по питанию"
        dataBoxData={foodResponsibleSignatoresFilter}
        dataBoxSelection={foodResponsibleSignatoresFilterSelection}
        pleaseSelectText="Нет данных"
        disabled={pending}
        multiple={false}
        selectedAllOnEmptySelection={false}
        statusOnEmpty={StatusOnEmpty.Hidden}
        resetSelectionIfNoData
      />
    )
  )
}
